// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WehV","name":"styles_name__2019Y","phone":"styles_phone__2sfWa"};